import Button from '../ui/Button';
export default function About() {
  return (
    <section id="about" class="ui-card p-9 md:p-16">
      <div class="absolute -top-24 -right-24 w-64 h-64 bg-cyan-500/10 rounded-full blur-3xl"></div>

      <div class="relative z-10 flex flex-col items-center gap-4">
        <h2 class="font-display text-4xl font-bold text-white mb-6 tracking-tight">
          About Me
        </h2>
        <p class="font-body text-lg text-slate-300 leading-relaxed max-w-3xl">
          I am a dedicated developer with a passion for building futuristic,
          high-performance web applications. My expertise lies in bridging the gap
          between complex backend logic and sleek, intuitive user interfaces.
        </p>

        <div class="mt-8 flex gap-4 text-xs font-mono text-cyan-400/80">
          <span>#React</span> <span>#Tailwind</span> <span>#NodeJS</span>
        </div>
        <a href="/Oualla_Nacim.pdf" download="Oualla_Nacim_CV.pdf" className='mt-10'>
          <Button>
            Download CV
          </Button>
        </a>
      </div>
    </section>
  )
}